module.exports = __webpack_public_path__ + "img/index-about-bg-01.04e78d70.png";